class Size{
    constructor(width, heigth){
        this.width = width;
        this.heigth = heigth;
    }
}

export default Size;